import { z } from 'zod';

export enum EmployeeByActivityPoleType {
	Blocked = 'bloqueado',
	Allowed = 'liberado',
	InRisk = 'risco',
}

export enum EmployeeByActivityPoleTrainingStatus {
	GRACE_PERIOD = 'Período de Carência',
	VALID = 'Válido',
	PENDING = 'Pendente',
	EXPIRES_IN_45_DAYS = 'Vence em até 45 dias',
	EXPIRES_IN_30_DAYS = 'Vence em até 30 dias',
	EXPIRES_IN_15_DAYS = 'Vence em até 15 dias',
	EXPIRED = 'Vencido',
	INVALID = 'Inválido',
}

export const validStatuses = [
	EmployeeByActivityPoleTrainingStatus.VALID,
	EmployeeByActivityPoleTrainingStatus.EXPIRES_IN_15_DAYS,
	EmployeeByActivityPoleTrainingStatus.EXPIRES_IN_30_DAYS,
	EmployeeByActivityPoleTrainingStatus.EXPIRES_IN_45_DAYS,
	EmployeeByActivityPoleTrainingStatus.GRACE_PERIOD,
];

export const atRiskOfBlockingStatuses = [
	EmployeeByActivityPoleTrainingStatus.EXPIRES_IN_15_DAYS,
	EmployeeByActivityPoleTrainingStatus.EXPIRES_IN_30_DAYS,
	EmployeeByActivityPoleTrainingStatus.EXPIRES_IN_45_DAYS,
	EmployeeByActivityPoleTrainingStatus.GRACE_PERIOD,
];

export const employeeByActivityPoleTrainingStatusesColors = {
	[EmployeeByActivityPoleTrainingStatus.VALID]: 'bg-[#2E7D32]',
	[EmployeeByActivityPoleTrainingStatus.EXPIRES_IN_45_DAYS]: 'bg-[#FFB800]',
	[EmployeeByActivityPoleTrainingStatus.EXPIRES_IN_30_DAYS]: 'bg-[#FF9F04]',
	[EmployeeByActivityPoleTrainingStatus.EXPIRES_IN_15_DAYS]: 'bg-[#FF6A00]',
	[EmployeeByActivityPoleTrainingStatus.GRACE_PERIOD]: 'bg-[#FF6A00]',
	[EmployeeByActivityPoleTrainingStatus.PENDING]: 'bg-[#F4503A]',
	[EmployeeByActivityPoleTrainingStatus.EXPIRED]: 'bg-[#F4503A]',
	[EmployeeByActivityPoleTrainingStatus.INVALID]: 'bg-[#F4503A]',
};

export const EmployeeByActivityPoleTrainingSchema = z.object({
	id: z.number(),
	name: z.string(),
	trainingControlId: z.number(),
	trainingType: z.string(),
	status: z.nativeEnum(EmployeeByActivityPoleTrainingStatus),
	initialBlockedDate: z.coerce.date().nullable(),
	blockDatePrediction: z.coerce.date().nullable(),
	validityDate: z.coerce.date().nullable(),
	nextTrainingDate: z.coerce.date().nullable(),
});

export const EmployeeByActivityPoleEmployeeSchema = z.object({
	id: z.number(),
	name: z.string(),
	alias: z.string().nullable(),
	employeeNumber: z.string(),
	jobTitle: z.string(),
	workStation: z.string(),
	board: z.string(),
	management: z.string(),
	coordination: z.string(),
	trainings: z.array(EmployeeByActivityPoleTrainingSchema),
});

export const EmployeeByActivityPoleSchema = z.object({
	date: z.coerce.date(),
	employees: z.array(EmployeeByActivityPoleEmployeeSchema),
});

export const EmployeeByActivityPoleResponseSchema = z.object({
	count: z.coerce.number(),
	nextPage: z.number().optional(),
	turnstileAccess: EmployeeByActivityPoleSchema,
});

export type EmployeeByActivityPoleTraining = z.infer<
	typeof EmployeeByActivityPoleTrainingSchema
>;
export type EmployeeByActivityPoleEmployee = z.infer<
	typeof EmployeeByActivityPoleEmployeeSchema
>;
export type EmployeeByActivityPole = z.infer<
	typeof EmployeeByActivityPoleSchema
>;

const EmployeeByActivityPoleFilterSingleOption = z
	.string()
	.transform((value) => ({
		value,
		label: value,
	}));

export const EmployeeByActivityPoleFilterOptionsSchema = z.object({
	management: z.array(EmployeeByActivityPoleFilterSingleOption).default([]),
	workstation: z.array(EmployeeByActivityPoleFilterSingleOption).default([]),
	board: z.array(EmployeeByActivityPoleFilterSingleOption).default([]),
	jobTitle: z.array(EmployeeByActivityPoleFilterSingleOption).default([]),
	coordination: z.array(EmployeeByActivityPoleFilterSingleOption).default([]),
	pole: z.array(EmployeeByActivityPoleFilterSingleOption).default([]),
	activity: z.array(EmployeeByActivityPoleFilterSingleOption).default([]),
	conditionTraining: z
		.array(EmployeeByActivityPoleFilterSingleOption)
		.default([]),
	conditionStatus: z
		.array(EmployeeByActivityPoleFilterSingleOption)
		.default([]),
});

export const EmployeeByActivityPoleCountSchema = z.object({
	allowed: z.coerce.number(),
	blocked: z.coerce.number(),
	atRiskOfBlocking: z.coerce.number(),
});

export type EmployeeByActivityPoleFilterOptions = z.infer<
	typeof EmployeeByActivityPoleFilterOptionsSchema
>;
